import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { requestSpaceContents } from '../../actions/spaces/RequestSpaceContentsActions';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { RecentsSpace, RecentsSpaceDispatchProps, RecentsSpaceOwnProps, RecentsSpaceStateProps } from './RecentsSpace';

const mapStateToProps: MapStateToProps<RecentsSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<RecentsSpaceDispatchProps> = (dispatch) => bindActionCreators({
  requestSpaceContents,
}, dispatch);

export const ConnectedRecentsSpace: React.ComponentClass<RecentsSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(RecentsSpace);
